import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { adminApi } from "../../../../../../services/Api/Admin/adminApi";
import { OrganizationsDashboardApi } from "../../../../../../services/Api/types";
import ChurnCard from "../../../../components/Admin/Dashboard/ChurnCard";

const AdminDashboardPage = () => {
	const [organizationsDashboard, setOrganizationsDashboard] = useState<OrganizationsDashboardApi | undefined>(
		undefined
	);
	const { addFlash } = useFlash();
	const { t } = useTranslation("admin");
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(`${t("modules.dashboard.header.title")} | ${t("lib:go_component.navigation.admin")}`);
		onFetch();
	}, []);

	const onFetch = async () => {
		try {
			const res = await adminApi.getOrganizationsDashboard();
			setOrganizationsDashboard(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!organizationsDashboard) return <LoadingContainer />;

	return (
		<div className={"content"}>
			<Header title={t("lib:go_component.navigation.admin")} />
			<div className={"content-preview-body"}>
				<div className={"row"}>
					<div className={"col-md-4"}>
						<ChurnCard isAdminMode dashboard={organizationsDashboard} type="DEFAULT" />
						<ChurnCard isAdminMode dashboard={organizationsDashboard} type="FUTURE" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default AdminDashboardPage;
